import { useMemo } from 'react';
export const useIconSize = ({ size }) => {
    const iconSize = useMemo(() => {
        switch (size) {
            case 'small':
                return 'sm';
            case 'medium':
                return 'xl';
            case 'large':
                return 'xl2';
        }
    }, [size]);
    return iconSize;
};
